import React from 'react';
import Reports from './Reports';

const InstructorAttendanceReport = () => <Reports instructorScope />;

export default InstructorAttendanceReport;
